import React from "react";
import { Form } from "antd";
import { Editor } from "@progress/kendo-react-editor";
import { AdvancedToolbar } from "../../common/components/EditorToolbar";

type Props = {
    isTemplateApplied: boolean;
    selectedTaskTemplateId?: string | null;
    value: string;
};

const TaskCreateDescriptionField: React.FC<Props> = ({
    isTemplateApplied,
    selectedTaskTemplateId,
    value,
}) => (
    <Form.Item
        name="description"
        // The editor owns its value; Form.Item must only capture its HTML.
        getValueProps={() => ({})}
        getValueFromEvent={(event) => event.html}
        colon={false}
        className="dialog-field"
        label={<span className="dialog-field-label">Description</span>}
    >
        <Editor
            key={selectedTaskTemplateId || "new"}
            className={`${isTemplateApplied ? "disabled" : ""}`}
            defaultEditMode="div"
            tools={isTemplateApplied ? undefined : AdvancedToolbar}
            contentStyle={
                isTemplateApplied
                    ? { height: 150, opacity: 0.4, pointerEvents: "none" }
                    : { height: 150 }
            }
            value={value}
        />
    </Form.Item>
);

export default TaskCreateDescriptionField;
